import { PlayerType } from '../../note-view-media-sync-manager/core/note-view-media-sync-manager.interface';
import { IRemoteMediaSyncManagerInjectable } from '../core/interface';

export class RemoteSyncManagerInjectable implements IRemoteMediaSyncManagerInjectable {
    public attachMediaEventInPlayer = (playType: PlayerType) => playType === PlayerType.DESKTOP;
}
